/*    
<summary>
  This functional component "TimeSettingPopupHOC" provides props to the child component.
  1. State "showTimeSettingPopup" that manages the show/hide of pop up
  2. Function "TimeSettingPopupToggleHandler" to toggle the show/hide popup state "showTimeSettingPopup"
  Developer:Ashutosh Modgil, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date:26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import React, { useState } from "react";

const TimeSettingPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showTimeSettingPopup, setShowTimeSettingPopup] =
      useState<boolean>(false);

    const timeSettingToggleHandler = () => {
      setShowTimeSettingPopup(!showTimeSettingPopup);
    };

    return (
      <Component
        showTimeSettingPopup={showTimeSettingPopup}
        timeSettingPopupToggleHandler={timeSettingToggleHandler}
        {...props}
      />
    );
  };

export default TimeSettingPopupHOC;
